export default __webpack_public_path__ + "static/media/quickshot5.6e0cdbe4.png";